import { FC } from "react";
import { PostData } from "components/resources/resourceArticle/types";
import { LatestCaseStudy } from "utils/server";
import { Category } from "pages/resource-hub";
import { Page } from "../../templates/Page";
import { ResourceArticleBody } from "./ResourceArticleBody";
import RecommendedResources from "./RecommendedResources";
import { ExploreOtherCategoriesSection } from "../resourceHub/ExploreOtherCategories";
import { ContentType } from "@utils";
import { YuLifeLocale } from "@hooks";

interface ResourceArticleProps {
  latestCaseStudy?: LatestCaseStudy;
  postData?: PostData;
  contentType?: ContentType;
  recommendedResources: any[];
  isCategories: boolean;
  path?: string;
  categories?: Category[];
  locale: YuLifeLocale;
}

const ResourceArticle: FC<ResourceArticleProps> = ({
  latestCaseStudy,
  postData,
  contentType,
  recommendedResources,
  isCategories,
  path,
  categories,
  locale,
}) => {
  return (
    <Page hero={null} latestCaseStudy={latestCaseStudy}>
      <ResourceArticleBody contentType={contentType} postData={postData} locale={locale} />
      <RecommendedResources
        recommendedResources={recommendedResources}
        contentType={contentType}
        locale={locale}
      />
      {isCategories && contentType === ContentType.blog ? (
        <ExploreOtherCategoriesSection path={path} categories={categories} />
      ) : null}
    </Page>
  );
};

export default ResourceArticle;
